<template>
  <div class="readyExamOnline">
    <el-card class="box-card">
      <div class="cardTitle" v-html="titleText"></div>
      <div class="dateRangeStyle" v-if="dateRange">{{dateRange}}</div>
      <div class="btnGroup">
        <el-button v-show="signUpBtnShow" style="margin:0 10px" @click="signUpExam" type="primary" >报名</el-button>
        <el-button v-show="beginBtnShow" style="margin:0 10px" @click="beginExam" type="primary" >{{btnText}}</el-button>
        <el-tag type="info" disable-transitions v-if="showSignUpAlready">已报名</el-tag>
        <!-- <el-button style="margin:0 10px" @click="logOut">退出登录</el-button> -->
      </div>
    </el-card>
    <Login></Login>
  </div>
</template>

<script type="text/javascript">
import testPaperApi from "@/request/api/testPaper";
import testApi from "@/request/api/test";
import userApi from '@/request/api/user';
import Login from '@/components/loginDialog';
import { mapGetters } from "vuex";
export default {
  components: { Login },
  computed:{
    ...mapGetters(["studentId"])
  },
  data() {
    return {
      titleText:'',
      beginTime:0,
      endTime:0,
      nowTime:0,
      countDownInterval:null,
      durationTime:null,
      beginTimeText:'',
      durationTimeText:null,
      beginBtnShow:false,
      testId:'',
      examId:'',
      signUpBtnShow:false,
      btnText:'开始考试',
      examType:'',
      testInfo:{},
      dateRange:'',
      showSignUpAlready:false,
      hostName: location.hostname
    }
  },
  created () {
    this.getQuery()
  },
  methods: {
    // 获取query信息
    getQuery(){
      let querys=this.$route.query
      if(querys.testId){
        this.testId=querys.testId
        this.findTest(querys.testId)
      }
      this.examId=querys.id?querys.id:''
    },
    // 查找考试信息
    findTest(id){
      return new Promise(resolve => {
        testApi.findTest(id,async res=>{
          if(res.succeed){
            this.testInfo=res.data
            let now=this.$moment(new Date())
            if((res.data.referencePerson=='手动指定'||!res.data.referencePerson)&&(res.data.referenceTimeType=='固定时间考试'||!res.data.referenceTimeType)){
              // 有试卷 试卷有时间 走正常考试模式
              this.newGetTestTimes()
              this.examType="手动固定"
            }else if((res.data.referencePerson=='手动指定'||!res.data.referencePerson)&&res.data.referenceTimeType=='随到随考'){
                // 随到随考  指定人  
                //    1.先拿考试信息 判断时间段
                //      时间段之前报名  
                //      时间段之中  先查这个人有没有这个考试的试卷  有的话判断有没有考试时间 如有 没过期继续考试  过期考试已完成， 如没有，开始考试  
                //      时间段之后  考试已结束
              this.examType="手动随考" 
              let startDate=this.$moment(res.data.startDate)
              let endDate=this.$moment(res.data.endDate)
              if(now<startDate){
                this.titleText=`未到考试时间`
                this.dateRange=`考试时间：${res.data.startDate}~${res.data.endDate}`
              }else if(now>=startDate&&now<endDate){
                let responce=await this.findPaperByTestId()
                if(responce.data.status=='可用'){
                  this.titleText = `考试时长：${this.testInfo.timeRange}分钟`
                  this.beginBtnShow=true
                }else if(responce.data.status=='已开考'){
                  let endTime = this.$moment(`${responce.data.testDateYTD} ${responce.data.endTime}`)
                  if(now>endTime){
                    this.titleText = `考试已结束`
                  }else{
                    this.examId=responce.data.id
                    this.$nextTick(()=>{
                      this.newGetTestTimes()
                    })
                  }
                }else{
                  this.titleText = `考试已结束`
                }
              }else{
                this.titleText = `考试已结束`
              }
            }else if(res.data.referencePerson=='开放报名'&&(res.data.referenceTimeType=='固定时间考试'||!res.data.referenceTimeType)){
              // 固定时间  开放报名  
              //    先拿考试信息 判断时间段
              //      时间段之前报名  然后拉时间
              //      时间段之中  先查这个人有没有这个考试的试卷  有的话拉时间  没有立即报名并考试
              //      时间段之后  考试已结束
              this.examType="开放固定"
              let startTime=this.$moment(`${res.data.testDateYTD} ${res.data.startTime}`)
              let endTime=this.$moment(`${res.data.testDateYTD} ${res.data.endTime}`)
              let responce=await this.findPaperByTestId()
              if(!responce.data){
                if(now<startTime){
                  this.titleText=`未到考试时间`
                  this.dateRange=`考试时间：${res.data.testDateYTD} ${res.data.startTime}~${res.data.endTime}`
                  this.signUpBtnShow=true
                }else if(now>=startTime&&now<endTime){
                  this.titleText = `考试已开始`
                  this.btnText='报名并开始考试'
                  this.beginBtnShow=true
                }else{
                   this.titleText = `考试已结束`
                }
              }else{
                this.examId=responce.data.id
                this.$nextTick(()=>{
                  this.newGetTestTimes()
                })
              }
            }else if(res.data.referencePerson=='开放报名'&&res.data.referenceTimeType=='随到随考'){
              // 随到随考  开放报名  
              //    先拿考试信息 判断时间段
              //      时间段之前报名  然后拉时间
              //      时间段之中  先查这个人有没有这个考试的试卷  有的话判断试卷状态 如等于已开考，且结束时间之前继续考试  如等于已判卷 考试结束  如等于可用  开始考试 
              //      时间段之后  考试已结束
              let startDate=this.$moment(res.data.startDate)
              let endDate=this.$moment(res.data.endDate)
              this.examType="开放随考"
              if(now<startDate){
                let responce=await this.findPaperByTestId()
                this.titleText=`未到考试时间`
                this.dateRange=`考试时间：${res.data.startDate}~${res.data.endDate}`
                if(!responce.data){
                  this.signUpBtnShow=true
                }else{
                  this.showSignUpAlready=true
                }
              }else if(now>=startDate&&now<endDate){
                let responce=await this.findPaperByTestId()
                if(!responce.data){
                  this.titleText = `考试时长：${this.testInfo.timeRange}分钟`
                  this.btnText='报名并开始考试'
                  this.beginBtnShow=true
                }else{
                  if(responce.data.status=='可用'){
                    this.titleText = `考试时长：${this.testInfo.timeRange}分钟`
                    this.examId=responce.data.id
                    this.beginBtnShow=true
                  }else if(responce.data.status=='已开考'){
                    let endTime = this.$moment(`${responce.data.testDateYTD} ${responce.data.endTime}`)
                    if(now>endTime){
                      this.titleText = `考试已结束`
                    }else{
                      this.examId=responce.data.id
                      this.$nextTick(()=>{
                        this.newGetTestTimes()
                      })
                    }
                  }else{
                    this.titleText = `考试已结束`
                  }
                }
              }else{
                this.titleText = `考试已结束`
              }
            }
          }
          resolve()
        })
      })
    },
    // 获取考试时间
    newGetTestTimes() {
      testPaperApi.newGetTestTimes(this.examId, res => {
        if (res.succeed) {
          if (res.data == null) {
            this.titleText = "今日无考试";
          } else{
            if(this.examType=="开放固定"&&this.testInfo.userIds&&!this.testInfo.userIds.includes(this.studentId)){
              this.signUpBtnShow=true
            }
            this.beginTime = res.data[0] ? res.data[0] : 0;
            this.beginTimeText=this.$moment(this.beginTime).format('hh:mm:ss')
            this.endTime = res.data[1] ? res.data[1] : 0;
            this.nowTime = res.data[2] ? res.data[2] : 0;
            if(this.nowTime<this.beginTime){
              this.durationTime=this.beginTime-this.nowTime
              this.countDownInterval=setInterval(() => {
                this.durationTime--
                let hour,min,sec
                if (this.durationTime >= 0) {
                  let h = Math.floor((this.durationTime / 60 / 60) % 24);
                  hour = h < 10 ? "0" + h : h.toString();
                  let m = Math.floor((this.durationTime / 60) % 60);
                  min = m < 10 ? "0" + m : m.toString();
                  let s = Math.floor(this.durationTime % 60);
                  sec = s < 10 ? "0" + s : s.toString();
                  this.titleText=`距离开考还有<span>${hour}:${min}:${sec}</span>`
                } else {
                  clearInterval(this.countDownInterval)
                  hour = "00";
                  min = "00";
                  sec = "00";
                  if(this.examType=="开放固定"&&this.testInfo.userIds&&!this.testInfo.userIds.includes(this.studentId)){
                    this.btnText='报名并开始考试'
                  }
                  this.beginBtnShow=true
                  this.signUpBtnShow=false
                  this.titleText = "考试已经开始";
                }
              }, 1000);
            }else if(this.nowTime>=this.beginTime&&this.nowTime<=this.endTime){
              this.beginBtnShow=true
              this.titleText = "考试已经开始";
            }
          }
        }
      });
    },
    // 开始考试
    async beginExam(){
      if(userApi.getToken()) {
        if(this.btnText=='报名并开始考试'){
          let result=await this.savePaper()
          if(!result){
            return false 
          }
        }
        if(this.examId){
          window.location.href = `https://${this.hostName}/psp/examCenter/ExamOnline?id=${this.examId}`;
        }
      } else this.$store.commit('setDialogVisible', true)
      
    },
    // 报名confirm
    signUpExam(){
      if(userApi.getToken()) {
        this.$confirm('是否要报名本考试?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            let result=await this.savePaper()
            if(result){
              this.$message({
                message: '报名成功',
                type: 'success'
              });
              this.signUpBtnShow=false
              this.showSignUpAlready=true
            } else {
              userApi.deleteToken();
            }
        }).catch(() => {
            console.log('取消操作')
        });
      } else {
        this.$store.commit('setDialogVisible', true)
      }
    },
    // 自主报名
    savePaper(){
      return new Promise(resolve => {
        testPaperApi.savePaper(this.testId,res=>{
          if(res.succeed){
            this.examId=res.data
          }
          resolve(res.succeed)
        })
      })
    },
    // 查本场考试有没有试卷
    findPaperByTestId(){
      return new Promise(resolve => {
        testPaperApi.findPaperByTestId(this.testId,res=>{
          resolve(res)
        })
      })
    },
  }
}
</script>
<style lang="scss">
.readyExamOnline{
  min-height: 100vh;
  padding: 12vh 0 0;
  background:#E4E7ED;
  .box-card{
    margin: 0 auto;
    width: 75%;
    height: 60vh;
    animation: animateShadow 5s linear 2s infinite alternate;
    .cardTitle{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 80px;
      font-weight: normal;
      letter-spacing: 20px;
      color: #303133;
      height: 30vh;
      span{
        letter-spacing: 8px;
      }
    }
    .dateRangeStyle{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      color: #303133;
    }
    .btnGroup{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 20vh;
    }
  }
  @keyframes animateShadow {
    0%   {box-shadow: 0 5px 20px 0 rgba(255, 0, 0,0.9);}
    25%  {box-shadow: 0 10px 20px 0 rgba(255, 255, 0,0.7);}
    50%  {box-shadow: 0 15px 20px 0 rgba(0, 0, 255,0.5);}
    75%  {box-shadow: 0 10px 20px 0 rgba(0, 128, 0,0.7);}
    100% {box-shadow: 0 5px 20px 0 rgba(255, 0, 0,0.9);}
  }
}

</style>



// WEBPACK FOOTER //
// src/views/exam/readyExam.vue